function getCurrentLocale (key) {
  const initial = {
    'pt-br': 'pt-BR',
    'en-us': 'en-US',
    'es-cl': 'es-CL'
  }
  return initial[key]
}

export const translator = { getCurrentLocale }
